import { isProd } from 'config/config';
import { API } from 'helpers/api';
import { formatDate, formatMoney } from 'helpers/utils';

import Vue from 'vue/dist/vue';
import Vuex from 'vuex/dist/vuex';

import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker';
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css';
import format from 'date-fns/format';

const invoiceHistoryEl = document.querySelector('#invoice-history');
if (invoiceHistoryEl) {
    Vue.use(AirbnbStyleDatepicker, {
        sundayFirst: true,
        colors: {
            selected: '#ea7200',
            inRange: '#ea7200',
            inRangeBorder: '#ea7200',
            hoveredInRange: '#ff810a',
        },
    });
    Vue.use(Vuex);

    const invoiceHistory = new Vuex.Store({
        state: {
            response: {},
            isLoading: true,
            dates: {
                startDate: '',
                endDate: '',
            },
            maximumInvoices: 250,
            currentPage: 1,
            paginationInput: 1,
        },
        mutations: {
            setSearchDate: function (state, payload) {
                let startDate = new Date(payload.dateOne + 'T06:00:00.000Z');
                let endDate = new Date(payload.dateTwo + 'T06:00:00.000Z');

                function formatDates(monthOrDate) {
                    return monthOrDate < 10 ? '0' + monthOrDate : '' + monthOrDate;
                }

                state.dates.startDate = `${startDate.getFullYear()}-${formatDates(
                    startDate.getMonth() + 1,
                )}-${formatDates(startDate.getDate())}`;
                state.dates.endDate = `${endDate.getFullYear()}-${formatDates(
                    endDate.getMonth() + 1,
                )}-${formatDates(endDate.getDate())}`;
            },
            setCurrentPage: function (state, payload) {
                state.currentPage = payload;
            },
            setPaginationInput: function (state, payload) {
                state.paginationInput = payload;
            },
        },
        actions: {
            GetInvoices: async function (context) {
                let res = await API.invoices.history.get(
                    context.state.dates.startDate,
                    context.state.dates.endDate,
                    context.state.maximumInvoices,
                );
                console.log(res);
                if (!res.error) {
                    if (res.results) context.state.response = res.results;

                    context.state.dates.startDate = res.SearchInvoiceDateStart;
                    context.state.dates.endDate = res.SearchInvoiceDateEnd;

                    context.state.currentPage = 1;
                    context.state.paginationInput = 1;
                }

                context.state.isLoading = false;
            },
        },
    });

    Vue.component('calendar', {
        template: '#calendar',
        data: function () {
            return {
                dateFormat: 'M/D/YYYY',
            };
        },
        computed: {
            dates: {
                get: function () {
                    return {
                        dateOne: invoiceHistory.state.dates.startDate,
                        dateTwo: invoiceHistory.state.dates.endDate,
                    };
                },
            },
        },
        methods: {
            formatDates: function (dateOne, dateTwo) {
                let formattedDates = '';
                if (dateOne) {
                    formattedDates = format(dateOne, this.dateFormat);
                }
                if (dateTwo) {
                    formattedDates += ' - ' + format(dateTwo, this.dateFormat);
                }
                return formattedDates;
            },
            updateDates: function () {
                invoiceHistory.commit('setSearchDate', this.dates);
                invoiceHistory.dispatch('GetInvoices');
            },
        },
    });

    new Vue({
        el: '#invoice-history',
        invoiceHistory,
        data: {
            searchFilter: '',
            pageSize: 20,
        },
        computed: {
            isProd: function () {
                return isProd;
            },
            isLoading: function () {
                return invoiceHistory.state.isLoading;
            },
            filteredInvoices: function () {
                if (invoiceHistory.state.response) {
                    return invoiceHistory.state.response.records.filter((invoice) => {
                        var lowerSearch = this.searchFilter.toLowerCase();

                        if (
                            !lowerSearch ||
                            invoice.templateitem.invoicenumber.toLowerCase().match(lowerSearch) ||
                            (invoice.templateitem.cinumber &&
                                invoice.templateitem.cinumber.toLowerCase().match(lowerSearch))
                        ) {
                            return true;
                        }
                        for (var i = 0; i < invoice.related.length; i++) {
                            var it = invoice.related[i];
                            if (it && it.toLowerCase().match(lowerSearch)) {
                                return true;
                            }
                        }
                        return false;
                    });
                } else {
                    return [];
                }
            },
            currentPage: {
                get: function () {
                    return invoiceHistory.state.currentPage;
                },
                set: function (newPage) {
                    invoiceHistory.commit('setCurrentPage', newPage);
                },
            },
            paginationInput: {
                get: function () {
                    return invoiceHistory.state.paginationInput;
                },
                set: function (newPage) {
                    invoiceHistory.commit('setPaginationInput', newPage);
                },
            },
            disablePreviousLink: function () {
                return this.currentPage <= 1 ? true : false;
            },
            disableNextLink: function () {
                return this.currentPage >= this.totalNumOfPages ? true : false;
            },
            visibleInvoices: function () {
                return this.filteredInvoices.slice(
                    (this.currentPage - 1) * this.pageSize,
                    (this.currentPage - 1) * this.pageSize + this.pageSize,
                );
            },
            totalNumOfPages: function () {
                let filledPages = Math.floor(this.filteredInvoices.length / this.pageSize);
                let remainder = this.filteredInvoices.length % this.pageSize;

                if (remainder) {
                    return filledPages + 1;
                } else {
                    return filledPages;
                }
            },
            visibleInvoicesLow: function () {
                if (!this.filteredInvoices.length) {
                    return 0;
                } else {
                    return this.pageSize * this.currentPage - (this.pageSize - 1);
                }
            },
            visibleInvoicesHigh: function () {
                if (this.currentPage == this.totalNumOfPages) {
                    return this.filteredInvoices.length;
                } else {
                    return this.currentPage * this.pageSize;
                }
            },
        },
        filters: {
            formatDate: function (date) {
                return formatDate(date);
            },
            formatMoney: function (price) {
                return formatMoney(price);
            },
            formatInvoiceDetailsURL: function (invoice) {
                let invoicelink = isProd ? '/print/invoice' : 'https://pd.web.local/Print/Invoice';
                let cilink = isProd ? '/print/ciprint' : 'https://pd.web.local/Print/ciprint';
                let credlink = isProd ? '/print/credit' : 'https://pd.web.local/Print/credit';
                switch (invoice.templateitem.type) {
                    case 'CustInvc':
                    case 'CashSale':
                        if (invoice.templateitem.ciinternalid)
                            return `${cilink}?orderNumber=${
                                invoice.templateitem.invoicenumber
                            }&cinumber=${invoice.templateitem.cinumber || ''}&ciid=${
                                invoice.templateitem.ciinternalid || ''
                            }`;
                        else
                            return `${invoicelink}?orderNumber=${
                                invoice.templateitem.invoicenumber
                            }&cinumber=${invoice.templateitem.cinumber || ''}&ci=${
                                invoice.templateitem.ciinternalid || ''
                            }`;
                    case 'CustCred':
                    case 'CashRfnd':
                        return `${credlink}?orderNumber=${invoice.templateitem.invoicenumber}`;
                    default:
                        break;
                }

                // if (invoice.templateitem.send810 == 'T' && invoice.templateitem.cinumber) {
                //   return link + '?orderNumber=' + invoice.templateitem.invoicenumber + '&cinumber=' + invoice.templateitem.cinumber
                // } else {
                //   return link + '?orderNumber=' + invoice.templateitem.invoicenumber + '&cinumber='
                // }
            },
            getStatus: function (statusCode) {
                switch (statusCode) {
                    case '1210':
                        return 'Cancelled';
                    case '1211':
                        return 'In Process';
                    case '1212':
                        return 'Credit Memo';
                    case '1214':
                        return 'RMA';
                    case '1215':
                        return 'Open-Quote';
                    case '1216':
                        return 'Backordered';
                    case '1217':
                        return 'Future Delivery';
                    default:
                        return 'Shipped';
                }
            },
        },
        methods: {
            previousPage: function () {
                this.currentPage -= 1;
                this.paginationInput = this.currentPage;
            },
            nextPage: function () {
                this.currentPage += 1;
                this.paginationInput = this.currentPage;
            },
            validatePaginationInput: function () {
                if (this.paginationInput === '') {
                    return;
                } else if (
                    isNaN(this.paginationInput) ||
                    this.paginationInput > this.totalNumOfPages ||
                    this.paginationInput <= 0
                ) {
                    this.paginationInput = this.currentPage;
                } else {
                    let input = parseInt(this.paginationInput);
                    this.currentPage = input;
                    this.paginationInput = input;
                }
            },
            refreshPage: function () {
                if (this.filteredInvoices.length) {
                    this.currentPage = 1;
                    this.paginationInput = 1;
                } else {
                    return;
                }
            },
        },
        mounted() {
            console.log('blah');
            invoiceHistory.dispatch('GetInvoices');
        },
    });
}

const state = {
    pageGroup: 1,
    pageNum: 1,
    invoiceCount: 50,
    search: {},
    mini: false,
};

// ==================================================
// INITIALIZERS
// ==================================================

export async function fetchInvoices() {
    const res = await API.invoices.history.get(state.search);
    res.data.Invoices = res.data.Invoices || [];

    state.invoiceCount = res.data.Invoices.length;
    updateList(res.data.Invoices);
}

// // ==================================================
// // HELPERS
// // ==================================================

export function updateList(listItems) {
    state.pageGroup = 1;

    document.getElementsByClassName('js--invoice-list')[0].innerHTML = !listItems.length
        ? noItems()
        : listItems.map((k, i) => lineItem(k, i)).join('');
}

function lineItem(
    {
        ShipDate,
        CustomerPurchaseOrderDate: orderDate,
        CustomerPurchaseOrderNumber: po,
        InvoiceNumber: invoice,
        InvoiceAmount: total,
        InvoiceStatusCode: status,
    },
    i,
) {
    const ordered = orderDate && orderDate.length ? formatDate(orderDate) : 'N/A';
    const shipped = ShipDate && ShipDate.length ? formatDate(ShipDate) : 'N/A';
    const hidden = i > 10 ? 'list-grid__results--hidden' : '';

    const html = `<li class="js--pagination-page-${state.pageGroup} ${hidden}">
  <a href="${
      state.href
  }?orderNumber=${invoice}" target="_blank" rel="noopener" class="list-grid__results__item list-grid__result-link list-grid__results--link">
      <div class="list-grid__results__li" data-label="Order Date"><p>${ordered}</p></div>
      <div class="list-grid__results__li" data-label="PO #"><p>${po}</p></div>
      <div class="list-grid__results__li" data-label="Invoice #"><p>${invoice}</p></div>
      <div class="list-grid__results__li" data-label="Ship Date"><p>${shipped}</p></div>
      <div class="list-grid__results__li" data-label="Total"><p>${formatMoney(total)}</p></div>
      <div class="list-grid__results__li" data-label="Status"><p>${getStatus(status)}</p></div>
    </a>
  </li>`;

    if (i > 0 && i % 10 === 0) {
        state.pageGroup += 1;
    }

    return html;
}

const noItems = () =>
    `<li>
    <div class="list-grid__results__item">
      No items were found.
    </div>
  </li>`;

function getStatus(code) {
    switch (code) {
        case '1210':
            return 'Cancelled';
        case '1211':
            return 'In Process';
        case '1212':
            return 'Credit Memo';
        case '1214':
            return 'RMA';
        case '1215':
            return 'Open-Quote';
        case '1216':
            return 'Back Orders';
        case '1217':
            return 'Future Delivery';
        default:
            return 'Shipped';
    }
}

// ==================================================
// INIT
// ==================================================

async function init() {
    await fetchInvoices();
}

export default init;
